export interface AILoaderProps {
  title: string
  subtitle: string
}
